<template>
    <div id="HomeDiv">
        <HeaderVue isHeader="true"/>
                <!-- BEGIN banner-section -->
        <div class="section pb-0" >
            <div class="container">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="widget dashboard-box bg-green" v-on:click="onClickEvent(1)">
                            <div class="bg-icon pull-left">
                                <i class="fa fa-flask" aria-hidden="true"></i>
                            </div>
                            <div class="text-left heading">
                                <h3 class="text-dark"> Book Test </h3>
                            </div> 
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="widget dashboard-box bg-grayLight" v-on:click="onClickEvent(2)">
                            <div class="bg-icon pull-left">
                                <i class="fa fa-list-alt" aria-hidden="true"></i>
                            </div>
                            <div class="text-left heading">
                                <h3 class="text-white"> My Results </h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="widget dashboard-box bg-blue" v-on:click="onClickEvent(3)">
                            <div class="bg-icon pull-left">
                                <i class="fa fa-user" aria-hidden="true"></i>
                            </div>
                            <div class="text-left heading">
                                <h3 class="text-white"> My Profile </h3>
                            </div> 
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="widget dashboard-box bg-gray" v-on:click="onClickEvent(4)">
                            <div class="bg-icon pull-left">
                                <i class="fa fa-id-card-o" aria-hidden="true"></i>
                            </div>
                            <div class="text-left heading">
                                <h3 class="text-white"> Contact Us </h3>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <h2 class="section-title">Why Labotist</h2>
                        <div class="why-labotist flex-row">
                            <div class="future-list flex-nowrap flex-column">
                                <span class="sprites sprite-pickup align-center"></span>
                                <p>Free Home
                                    <br> Sample Pickup</p>
                            </div>
                            <div class="future-list flex-column">
                                <span class="sprites sprite-phlebotomists align-center"></span>
                                <p>Trained
                                    <br> Phlebotomists</p>
                            </div>
                            <div class="future-list flex-column">
                                <span class="sprites sprite-shield align-center"></span>
                                <p>Technology enabled &amp; safe
                                    <br> sample collection process</p>
                            </div>
                            <div class="future-list flex-column">
                                <span class="sprites sprite-star align-center"></span>
                                <p>Know
                                    <br> your labs better</p>
                            </div>
                            <div class="future-list flex-column">
                                <span class="sprites sprite-mobile align-center"></span>
                                <p>Get
                                    <br> Online Reports</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterVue foot= "true" />
    </div>
</template>

<script>
// import Login from '@/components/Login'
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import Vue from 'vue'

export default {
  name: 'Home',
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    this.query = this.$localStorage.get('location')
  },
  created () {
    setTimeout(function () {
      $("#carouselExampleControls").carousel()
      $("#carouselLabPartners").carousel()
    }, 1000)
  },
  data () {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    }
  },
  methods: {
    onClickEvent: function (type) {
      if(type === 1) {
        this.$router.push({ path: '/lab' })
      } else if(type === 2) {
        if(this.$localStorage.get('profile') && this.$localStorage.get('profile') != null){
          this.$router.push({ path: '/myresult' })
        }else{
          this.$root.$emit('myresultLogin',true);
        }
      } else if(type === 3) {
        if(this.$localStorage.get('profile') && this.$localStorage.get('profile') != null){
          this.$router.push({ path: '/myprofile' })
        }else{
          this.$root.$emit('myprofileLogin',true);
        }
      } else if(type === 4) {
        this.$router.push({ path: '/contact-us' })
      }
    }
  },
  watch: {
  },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Dashboard.vue